module.exports = __webpack_public_path__ + "static/pic01@3xwebp-fd69f9e400d1af6f1754fbe7d884afff.webp";